import { EventEmitter } from "events";
export const emitter = new EventEmitter()